"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.formalizer = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _recompose = require("recompose");

var _reactForm = require("react-form");

var _ruleValidations = require("./ruleValidations");

var _fieldsetter = require("./fieldsetter");

var formalize = function formalize(Field) {
  var FormalizedField = function FormalizedField(props) {
    var rules = props.rules,
        onChange = props.onChange,
        onValidate = props.onValidate,
        className = props.className,
        modifierChar = props.modifierChar,
        rulesToAddAsClassNames = props.rulesToAddAsClassNames,
        otherProps = (0, _objectWithoutPropertiesLoose2.default)(props, ["rules", "onChange", "onValidate", "className", "modifierChar", "rulesToAddAsClassNames"]);

    var _useContext = (0, _react.useContext)(_fieldsetter.FieldsetContext),
        fieldset = _useContext.fieldset;

    var _splitFormProps = (0, _reactForm.splitFormProps)(otherProps),
        field = _splitFormProps[0],
        fieldOptions = _splitFormProps[1],
        rest = _splitFormProps[2];

    var _useField = (0, _reactForm.useField)((0, _fieldsetter.relativeFieldset)(fieldset, field), (0, _extends2.default)({}, fieldOptions, {
      validate: function () {
        var _validate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(value, fieldInstance) {
          var ruleError, _error;

          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!rules) {
                    _context.next = 6;
                    break;
                  }

                  _context.next = 3;
                  return (0, _ruleValidations.validateRules)(fieldInstance, rules);

                case 3:
                  ruleError = _context.sent;

                  if (!ruleError.length) {
                    _context.next = 6;
                    break;
                  }

                  return _context.abrupt("return", ruleError[0]);

                case 6:
                  if (!onValidate) {
                    _context.next = 12;
                    break;
                  }

                  _context.next = 9;
                  return onValidate(value, fieldInstance);

                case 9:
                  _error = _context.sent;

                  if (!_error) {
                    _context.next = 12;
                    break;
                  }

                  return _context.abrupt("return", _error);

                case 12:
                  return _context.abrupt("return", false);

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function validate(_x, _x2) {
          return _validate.apply(this, arguments);
        }

        return validate;
      }()
    })),
        form = _useField.form,
        value = _useField.value,
        setValue = _useField.setValue,
        _useField$meta = _useField.meta,
        error = _useField$meta.error,
        isValidating = _useField$meta.isValidating,
        getInputProps = _useField.getInputProps;

    var localOnChange = function localOnChange(value) {
      setValue(value);

      if (onChange) {
        onChange(value, form);
      }
    };

    var rulesClassNames = (0, _react.useMemo)(function () {
      var _rules$filter;

      return (rules == null ? void 0 : (_rules$filter = rules.filter(function (rule) {
        return rulesToAddAsClassNames.includes(rule);
      })) == null ? void 0 : _rules$filter.map(function (rule) {
        return "Field" + modifierChar + rule;
      }).join(' ')) || '';
    }, [modifierChar, rules, rulesToAddAsClassNames]);
    return /*#__PURE__*/_react.default.createElement(Field, (0, _extends2.default)({}, getInputProps((0, _extends2.default)({}, rest)), {
      name: field,
      error: error,
      isValidating: isValidating,
      value: value,
      onChange: localOnChange,
      className: (className + " " + rulesClassNames).trim()
    }));
  };

  FormalizedField.propTypes = {
    field: _propTypes.default.string,
    validable: _propTypes.default.bool,
    rules: _propTypes.default.array,
    onChange: _propTypes.default.func,
    onValidate: _propTypes.default.func,
    className: _propTypes.default.string,
    modifierChar: _propTypes.default.string,
    rulesToAddAsClassNames: _propTypes.default.arrayOf(_propTypes.default.string)
  };
  FormalizedField.defaultProps = {
    modifierChar: '___',
    className: '',
    rulesToAddAsClassNames: ['required']
  };
  FormalizedField.displayName = "Formalized" + (Field.displayName || Field.name);
  return FormalizedField;
};

var conditionalFormalizer = (0, _recompose.branch)(function (_ref) {
  var field = _ref.field;
  return Boolean(field);
}, formalize);
var formalizer = conditionalFormalizer;
exports.formalizer = formalizer;
var _default = formalizer;
exports.default = _default;